import { Form, Input, Select } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  IAPIGameItem,
  IApplyDataList,
  IAPIServiceConfigItem,
  IAuditItem,
} from '../../../../model/api-modules';
import {
  GameEnvRegion,
  GameEnvType,
  IGameEnvCreate,
  IGameEnvModel,
} from '../../../../model/api-modules/env';
import {
  addEnv,
  updateEnv,
  getDictionaryConfig,
} from '../../../../api/game/env';
import { getLocalStorageStudioId } from '../../../utils/localstorage';
import { useSelector, useDispatch } from 'react-redux';
import {
  getEnvCollectionList,
  GamesAction,
} from '../../../../store/modules/games';
import { serviceOpenList, getServiceList } from '../../../../api/services';
import { Dispatch } from 'redux';
import { IRootState } from '../../../../store/reducers';
import { messageError, messageSuccess } from '../../../../components/message';
import { ModalWrap } from '../../../component/modal-wrap';
// import { BatchApplyModal } from '../../overview/batch-apply-modal';
import {
  formatGameParamsByLocationPathname,
  getPathnameBySwitchGameEnv,
} from '../../lib';
import { useHistory } from 'react-router-dom';
import getFormatMessage from '../../../../locales/get-format-message';
import { auditWriteLog } from '../../../lib/aduit-log';
import { BatchApplyDrawer } from '../../overview/batch-apply-drawer';
import { getCompanyInfo } from '../../../../api';
import { CustomPopover } from '../../../../components/custom-popover';
import { DeployArea } from '../../../../model';
import { getConfig } from '../../../../config';
import { throttle } from 'lodash';

interface IProps {
  readonly selectedGame?: IAPIGameItem;
  readonly refresh: () => void;
  readonly onClose: () => void;
  readonly isShow: boolean;
  readonly isEdit?: boolean;
  readonly selectRow?: IGameEnvModel | null;
}

export const CreateEnvModal = (props: IProps) => {
  const history = useHistory();
  const [formAdd] = Form.useForm();
  const envs = useSelector((state: IRootState) => state.games.envs);
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const gamesDispatch = useDispatch<Dispatch<GamesAction>>();
  const [isShowBatchApply, setIsShowBatchApply] = useState<boolean>(false);
  const [applyList, setApplyList] = useState<IApplyDataList[]>([]);
  const [openList, setOpenList] = useState<IAPIServiceConfigItem[]>([]);
  const [envId, setEnvId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [regionConfig, setRegionConfig] = useState<Record<string, any>>({});
  const [studioCertified, setStudioCertified] = useState<boolean>(false);
  const [envSelectRegion, setEnvSelectRegion] = useState<string>('');
  const deployArea: DeployArea = getConfig()?.deployArea;
  const isWoa = deployArea === DeployArea.woa;
  console.log(applyList, openList);

  useEffect(() => {
    fetchStudioCertInfo();
  }, [selectStudio?.studioID]);

  const fetchStudioCertInfo = async () => {
    if (!selectStudio?.studioID) {
      return;
    }
    const certInfo = await getCompanyInfo(selectStudio.studioID);
    setStudioCertified(certInfo?.isCertified || false);
  };

  const gameId = useMemo(() => {
    return props.selectedGame?.gameID || '';
  }, [props.selectedGame]);
  const getModalTitle = () => {
    if (props.isEdit) {
      return getFormatMessage('edit_environment');
    }
    return getFormatMessage('add_environment');
  };
  const getModalOkText = () => {
    if (props.isEdit) {
      return getFormatMessage('confirm');
    }
    return getFormatMessage('create');
  };
  const getServiceOpenList = async (GameId: string, EnvId: number) => {
    if (GameId && EnvId) {
      const res = await serviceOpenList(GameId, Number(EnvId));
      const result = await getServiceList();
      if (res && result) {
        const showApplyList: IAPIServiceConfigItem[] =
          JSON.parse(JSON.stringify(result)) || [];
        res.length !== 0 &&
          res.map((item) => {
            const isOpenItem = result.find((it) => it.id === item.ServiceID);
            if (isOpenItem) {
              showApplyList.splice(showApplyList.indexOf(isOpenItem), 1);
            }
            return showApplyList;
          });
        const showClassifyList: string[] = [];
        showApplyList.map((item) => {
          if (showClassifyList.indexOf(item.ParentName) === -1) {
            showClassifyList.push(item.ParentName);
          }
          return showClassifyList;
        });
        const dataList: IApplyDataList[] = [];
        showClassifyList.map((item) => {
          const itemList: IAPIServiceConfigItem[] = [];
          showApplyList.map((it) => {
            if (item === it.ParentName) {
              itemList.push(it);
            }
            return itemList;
          });
          dataList.push({
            title: item,
            commonServices: itemList,
            checkedList: [],
            parentSort: itemList[0].ParentSort || 0,
          });
          return dataList;
        });
        dataList.sort((pre, next) => pre.parentSort - next.parentSort);
        setOpenList(result);
        setApplyList(dataList);
        setEnvId(EnvId.toString());
      }
    }
  };

  const jumpEnv = (id: number) => {
    const { envId } = formatGameParamsByLocationPathname(location.pathname);
    // 无环境情况下如果添加环境成功，替换选中该环境
    if (envId === '0') {
      history.replace(getPathnameBySwitchGameEnv(Number(id)));
    }
  };
  const handleCreateOk = async (formData: {
    region: GameEnvRegion;
    envType: GameEnvType;
    envName: string;
    description: string;
  }) => {
    // setLoading(true);
    try {
      const studioId = getLocalStorageStudioId();
      if (studioId) {
        const body: IGameEnvCreate = {
          StudioID: studioId,
          GameID: gameId,
          Name: formData.envName,
          Type: formData.envType,
          Region: formData.region,
          Description: formData.description,
          ApiEndpoint: '',
          // ServiceIds: visibleCheckBox ? checkedValues.slice() : [],
          ServiceIds: [],
        };
        if (body) {
          const res = await addEnv(
            gameId,
            body,
            `${location.origin}/admin/service`
          );
          if (res) {
            auditWriteLog(IAuditItem.AddGameEnvironment, {
              gameID: gameId,
              envID: res.Guid,
              envType: res.Type,
              detail: {
                body,
                gameID: gameId,
                envID: res.Guid,
              },
            });
            await getEnvCollectionList(gamesDispatch)(studioId);
            messageSuccess(getFormatMessage('env_add_success'));
            formAdd.resetFields();
            props.onClose();
            props.refresh();
            jumpEnv(res.id);
            setIsShowBatchApply(true);
            getServiceOpenList(res.GameID, res.id);
          } else {
            messageError(getFormatMessage('env_add_fail'));
          }
        }
      }
    } catch (error: any) {
      messageError(
        error?.apiError?.message || getFormatMessage('env_add_fail')
      );
    }
    // setLoading(false);
    return true;
  };

  const handleEdit = async (envName: string, description: string) => {
    // setLoading(true);
    try {
      const envId = props.selectRow?.id;
      if (gameId && envId) {
        const body: Record<string, string> = {};
        if (props.selectRow.Name !== envName) {
          body.name = envName;
        }
        if (props.selectRow.Description !== description) {
          body.Description = description;
        }
        const res = await updateEnv(gameId, envId, body);
        const envItem = envs.find((item) => item.id === envId);
        if (envItem) {
          auditWriteLog(IAuditItem.EditGameEnvironment, {
            gameID: gameId,
            envID: envItem.Guid,
            envType: envItem.Type,
            detail: {
              envName,
              Description: description,
              gameID: gameId,
              envID: props.selectRow.Guid,
            },
          });
        }
        if (res.code === 0) {
          messageSuccess(getFormatMessage('edit_success'));
          formAdd.resetFields();
          props.onClose();
          props.refresh();
        } else {
          messageError(getFormatMessage('error_update'));
        }
      }
    } catch (error: any) {
      messageError(getFormatMessage('error_update'));
    }
    // setLoading(false);
    return true;
  };

  const throttledOnOkAdd = useMemo(() => {
    return throttle(async () => {
      setLoading(true);
      try {
        await formAdd.validateFields();
        const fieldsValue = formAdd.getFieldsValue();
        const envName = fieldsValue['Environment Name'] as string;
        const envType = fieldsValue['Environment Type'] as GameEnvType;
        const region = fieldsValue.Region as GameEnvRegion;
        const description = fieldsValue.Description || '';

        if (props.isEdit) {
          handleEdit(envName, description);
        } else {
          handleCreateOk({ region, envType, envName, description });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
      return true;
    }, 3000);
  }, [props.isEdit, props.selectedGame, props.selectRow]);

  // 组件卸载时清理
  useEffect(() => {
    return () => {
      throttledOnOkAdd.cancel();
    };
  }, [throttledOnOkAdd]);

  // 使用 useCallback 包装最终的函数
  const onOkAdd = useCallback(() => {
    const result = throttledOnOkAdd?.();
    return result ?? Promise.resolve(false);
  }, [throttledOnOkAdd]);

  const validateEnvName = (_rule: any, value: string) => {
    if (!value) {
      return Promise.reject(getFormatMessage('env_name_required'));
    }
    if (value.length > 64) {
      return Promise.reject(getFormatMessage('max_64'));
    }
    // 只允许字母和数字，中划线，下划线
    const regex = /^[a-zA-Z0-9_-]+$/;
    if (!regex.test(value)) {
      return Promise.reject(getFormatMessage('only_letters_numbers'));
    }
    const isNameExist = envs.some((item) => {
      return (
        (!props.isEdit && item.Name === value) ||
        (props.isEdit && item.Name === value && item.id !== props.selectRow?.id)
      );
    });
    if (isNameExist) {
      return Promise.reject(getFormatMessage('name_exists_tips'));
    }
    return Promise.resolve();
  };

  const getRegionConfig = async () => {
    const res = await getDictionaryConfig('config_env_region');
    if (res) {
      setRegionConfig(res);
    }
  };

  useEffect(() => {
    getRegionConfig();
  }, []);
  useEffect(() => {
    console.log('props.isEdit', props.isEdit);
    if (props.isEdit) {
      if (props.selectRow) {
        formAdd.setFieldsValue({
          Region: props.selectRow?.Region,
          'Environment Type': props.selectRow.Type,
          'Environment Name': props.selectRow.Name,
          Description: props.selectRow.Description || '',
        });
      }
    }
  }, [props.isEdit]);

  const handleClose = () => {
    formAdd.resetFields();
    props.onClose();
  };

  const getPopupContainer = (): HTMLElement => {
    const modalBody = document.querySelector('.ant-modal-body');
    if (modalBody) {
      return modalBody as HTMLElement; // 显式转换为 HTMLElement
    }
    return document.body as HTMLElement; // 如果 modalBody 为 null，则返回 document.body
  };

  const changeEnvRegion = (e: any) => {
    setEnvSelectRegion(e);
    const typeValue = formAdd.getFieldValue('Environment Type');
    if (e === GameEnvRegion.DevCloud && typeValue === GameEnvType.Live) {
      formAdd.setFieldValue('Environment Type', GameEnvType.Dev);
    }
  };

  const renderCreateDrawerContent = () => {
    const envRegion = regionConfig.config_env_region?.Value || [];

    const envOptions: any = [];
    envRegion.forEach((item: any) => {
      if (item?.value === GameEnvRegion.DevCloud) {
        if (isWoa) {
          envOptions.push({
            label: item?.label || '',
            value: item?.value || '',
          });
        }
      } else {
        let label = item?.label || '';
        if (isWoa && item?.value === GameEnvRegion.Woa) {
          label = (
            <>
              <span>{item?.label}</span>
              <span
                style={{
                  display: 'inline-block',
                  width: '40px',
                  height: '20px',
                  background: '#F7BA1E1A',
                  color: '#F7BA1E',
                  textAlign: 'center',
                  lineHeight: '20px',
                  borderRadius: '4px',
                  marginLeft: '4px',
                  fontSize: '12px',
                }}
              >
                {getFormatMessage('promo')}
              </span>
            </>
          );
        }
        envOptions.push({
          label,
          value: item?.value || '',
        });
      }
    });
    let typeTips = !studioCertified
      ? getFormatMessage('create_env_no_studio_auth')
      : '';
    if (envSelectRegion === GameEnvRegion.DevCloud) {
      typeTips = getFormatMessage('type_not_support_live');
    }
    return (
      <div>
        <Form
          form={formAdd}
          className="formEnv"
          name="basic"
          autoComplete="off"
          initialValues={{
            'Environment Type': GameEnvType.Dev, // 设置初始值为 "Dev"
          }}
          onFinish={onOkAdd}
          labelAlign="right"
          colon={false}
        >
          <Form.Item
            labelCol={{ span: 6 }}
            className="no-required-symbol"
            label={getFormatMessage('region')}
            name="Region"
            rules={[
              {
                required: true,
                message: getFormatMessage('region_is_required'),
              },
            ]}
          >
            <Select
              className="env-form-border"
              placeholder={getFormatMessage('select_your_region')}
              options={envOptions}
              disabled={props.isEdit}
              getPopupContainer={getPopupContainer}
              onChange={changeEnvRegion}
            />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 6 }}
            className="no-required-symbol"
            label={getFormatMessage('env_type')}
            name="Environment Type"
            rules={[
              {
                required: true,
                message: getFormatMessage('env_type_required'),
              },
            ]}
          >
            <Select
              className="env-form-border"
              placeholder={getFormatMessage('select_your_env_type')}
              getPopupContainer={getPopupContainer}
              options={[
                { value: GameEnvType.Dev, label: getFormatMessage('dev_type') },
                {
                  value: GameEnvType.Live,
                  label: (
                    <CustomPopover placement="bottomLeft" content={typeTips}>
                      <div> {getFormatMessage('live_type')}</div>
                    </CustomPopover>
                  ),
                  disabled:
                    !studioCertified ||
                    envSelectRegion === GameEnvRegion.DevCloud,
                },
              ]}
              disabled={props.isEdit}
              defaultValue={GameEnvType.Dev}
            />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 6 }}
            className="no-required-symbol env-name"
            label={getFormatMessage('environment_name')}
            name="Environment Name"
            colon={false}
            rules={[{ required: true, validator: validateEnvName }]}
          >
            <Input
              placeholder={getFormatMessage('enter_environment_name')}
              className="env-form-border"
            />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 6 }}
            className="no-required-symbol env-name"
            label={getFormatMessage('desc_information')}
            name="Description"
            colon={false}
          >
            <Input
              placeholder={getFormatMessage('enter_environment_desc')}
              className="env-form-border"
            />
          </Form.Item>
        </Form>
      </div>
    );
  };

  const renderModal = () => {
    if (props.isShow) {
      return (
        <ModalWrap
          className="add-env-modal"
          onOk={onOkAdd}
          loading={loading}
          cancelText={getFormatMessage('cancel')}
          oKText={getModalOkText()}
          onClose={handleClose}
          title={
            <p className="fail-title">
              <span>{getModalTitle()}</span>
            </p>
          }
        >
          {renderCreateDrawerContent()}
        </ModalWrap>
      );
    }
    return null;
  };

  const onCloseBatchApply = () => {
    setApplyList([]);
    setOpenList([]);
    setEnvId('');
    setIsShowBatchApply(false);
  };

  return (
    <div>
      {renderModal()}
      {/* {isShowBatchApply && applyList && openList && envId && (
        <BatchApplyModal
          onClose={onCloseBatchApply}
          applyList={applyList}
          gameId={gameId}
          envId={envId.toString()}
          openList={openList}
        />
      )} */}
      {envId && (
        <BatchApplyDrawer
          onClose={onCloseBatchApply}
          gameId={gameId}
          envId={Number(envId)}
          visible={isShowBatchApply}
        />
      )}
    </div>
  );
};
